import 'slick-carousel';

const imageCarousel = ( $ ) => {
	const initCarousel = ( $root ) => {
		const $main = $root.find( '.js-image-carousel-main' );
		const $nav = $root.find( '.js-image-carousel-nav' );
		const $caption = $root.find( '.image-carousel__caption' );
		const $prev = $root.find( '.image-carousel__nav-arrow--prev' );
		const $next = $root.find( '.image-carousel__nav-arrow--next' );

		if ( ! $main.length || ! $nav.length ) return;

		// Helper to set caption from the current active slide
		const setCaption = ( currentIndex = 0 ) => {
			const $current = $main
				.find( '.image-carousel__slide' )
				.eq( currentIndex );
			const cap = $current.data( 'caption' );
			if ( $caption.length ) {
				$caption.text( cap || '' );
			}
		};

		$main.slick( {
			asNavFor: $nav,
			arrows: true,
			prevArrow: $prev,
			nextArrow: $next,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: true,
			infinite: false,
			cssEase: 'ease',
			speed: 300,
		} );

		$nav.slick( {
			asNavFor: $main,
			arrows: false,
			focusOnSelect: true,
			slidesToShow: 6,
			slidesToScroll: 1,
			infinite: false,
			variableWidth: false,
			speed: 600,
			useTransform: true,
			cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
			responsive: [
				{ breakpoint: 767, settings: { slidesToShow: 3.5 } },
			],
		} );

		$main.on( 'init', ( e, slick ) => {
			setCaption( slick.currentSlide );
			updateThumbAria( slick.currentSlide );
		} );
		$main.on( 'afterChange', ( e, slick, current ) => {
			setCaption( current );
			updateThumbAria( current );
		} );

		// Keyboard support: arrows/Home/End on the carousel container control main slides
		$root.on( 'keydown', ( e ) => {
			const key = e.key;
			// If focus is inside an input-like element, do nothing
			const tag = ( e.target.tagName || '' ).toLowerCase();
			if (
				tag === 'input' ||
				tag === 'textarea' ||
				tag === 'select' ||
				e.target.isContentEditable
			)
				return;
			if ( ! $main.hasClass( 'slick-initialized' ) ) return;

			let handled = false;
			if ( key === 'ArrowLeft' ) {
				$main.slick( 'slickPrev' );
				handled = true;
			} else if ( key === 'ArrowRight' ) {
				$main.slick( 'slickNext' );
				handled = true;
			} else if ( key === 'Home' ) {
				$main.slick( 'slickGoTo', 0, true );
				handled = true;
			} else if ( key === 'End' ) {
				const slick = $main.slick( 'getSlick' );
				const last = slick ? slick.slideCount - 1 : 0;
				$main.slick( 'slickGoTo', last, true );
				handled = true;
			}
			if ( handled ) {
				e.preventDefault();
			}
		} );

		// Keyboard support on thumbs: Enter/Space activates; Arrows/Home/End move focus between thumbs
		$root.on( 'keydown', '.image-carousel__thumb', function ( e ) {
			if ( ! $nav.hasClass( 'slick-initialized' ) ) return;
			const $thumb = $( this );
			const $slide = $thumb.closest( '.slick-slide' );
			let index =
				typeof $slide.data( 'slick-index' ) === 'number'
					? $slide.data( 'slick-index' )
					: $nav.find( '.image-carousel__thumb' ).index( $thumb );
			const key = e.key;
			let handled = false;

			if ( key === 'Enter' || key === ' ' ) {
				$nav.slick( 'slickGoTo', index, true );
				handled = true;
			} else if ( key === 'ArrowLeft' || key === 'ArrowUp' ) {
				index = Math.max( 0, index - 1 );
				$nav.slick( 'slickGoTo', index, true );
				focusThumb( $nav, index );
				handled = true;
			} else if ( key === 'ArrowRight' || key === 'ArrowDown' ) {
				const slick = $nav.slick( 'getSlick' );
				const last = slick ? slick.slideCount - 1 : 0;
				index = Math.min( last, index + 1 );
				$nav.slick( 'slickGoTo', index, true );
				focusThumb( $nav, index );
				handled = true;
			} else if ( key === 'Home' ) {
				index = 0;
				$nav.slick( 'slickGoTo', index, true );
				focusThumb( $nav, index );
				handled = true;
			} else if ( key === 'End' ) {
				const slick = $nav.slick( 'getSlick' );
				index = slick ? slick.slideCount - 1 : 0;
				$nav.slick( 'slickGoTo', index, true );
				focusThumb( $nav, index );
				handled = true;
			}

			if ( handled ) {
				e.preventDefault();
			}
		} );

		function focusThumb( $nav, i ) {
			const $target = $nav.find(
				'.slick-slide[data-slick-index="' +
					i +
					'"] .image-carousel__thumb'
			);
			if ( $target.length ) $target.focus();
		}

		function updateThumbAria( current ) {
			$nav.find( '.image-carousel__thumb' ).attr(
				'aria-current',
				'false'
			);
			const $active = $nav.find(
				'.slick-slide[data-slick-index="' +
					current +
					'"] .image-carousel__thumb'
			);
			if ( $active.length ) {
				$active.attr( 'aria-current', 'true' );
			}
		}

		// If slick has already initialized before binding events, set caption now
		if ( $main.hasClass( 'slick-initialized' ) ) {
			const current = $main.slick( 'slickCurrentSlide' );
			setCaption( current );
			updateThumbAria( current );
		}
	};

	$( '.js-image-carousel' ).each( function () {
		initCarousel( $( this ) );
	} );
};

export default ( ( $ ) => $( imageCarousel ) )( jQuery );
